import React from "react";
import KipLogo from "@/components/kip/KipLogo";
import { Linkedin, Facebook } from "lucide-react";

const NAV = [
  { id: "about", label: "À propos" },
  { id: "metiers", label: "Nos Métiers" },
  { id: "wayne", label: "Wayne" },
  { id: "vision", label: "Vision 2030" },
  { id: "groupe", label: "Groupe EKIP" },
  { id: "contact", label: "Contact" },
];

export default function Footer() {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) {
      const y = el.getBoundingClientRect().top + window.scrollY - 72;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  return (
    <footer
      data-testid="footer-section"
      className="bg-[#0F1A2E] text-white relative"
    >
      {/* Orange accent */}
      <div aria-hidden className="h-1 bg-[#E85D26]" />

      <div className="kip-container py-16 lg:py-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10">
        {/* Brand */}
        <div className="lg:col-span-4">
          <KipLogo variant="light" size="h-24" />
          <p className="mt-5 text-white/60 text-sm leading-relaxed max-w-xs">
            L'énergie qui propulse la Côte d'Ivoire. Distributeur exclusif Wayne
            et acteur pétrolier de nouvelle génération.
          </p>
          <div className="mt-6 text-xs text-white/40 tracking-[0.24em] uppercase">
            Une filiale
          </div>
          <div className="font-display font-bold text-white mt-1">
            EKIP Holding Company
          </div>
          <div className="text-xs text-[#E85D26] mt-1 italic">
            « Ensemble, Vivons Mieux »
          </div>
        </div>

        {/* Nav */}
        <div className="lg:col-span-3">
          <div className="text-[10px] tracking-[0.24em] uppercase text-[#E85D26] font-bold mb-5">
            Navigation
          </div>
          <ul className="space-y-3">
            {NAV.map((n) => (
              <li key={n.id}>
                <button
                  onClick={() => scrollTo(n.id)}
                  data-testid={`footer-link-${n.id}`}
                  className="text-white/70 hover:text-[#E85D26] text-sm transition-colors"
                >
                  {n.label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div className="lg:col-span-3">
          <div className="text-[10px] tracking-[0.24em] uppercase text-[#E85D26] font-bold mb-5">
            Contact
          </div>
          <ul className="space-y-3 text-white/70 text-sm">
            <li>RCI — Abidjan, Cocody 2 Plateaux</li>
            <li>
              <a
                href="tel:+2252522010120"
                className="hover:text-[#E85D26] transition-colors block"
              >
                +225 25 22 01 01 20
              </a>
              <a
                href="tel:+2250502998703"
                className="hover:text-[#E85D26] transition-colors block"
              >
                +225 05 02 99 87 03
              </a>
            </li>
            <li>
              <a
                href="mailto:contact@kipenergy.ci"
                className="hover:text-[#E85D26] transition-colors"
              >
                contact@kipenergy.ci
              </a>
            </li>
            <li>Lun–Ven · 8h – 18h</li>
          </ul>
        </div>

        {/* Social + legal */}
        <div className="lg:col-span-2">
          <div className="text-[10px] tracking-[0.24em] uppercase text-[#E85D26] font-bold mb-5">
            Réseaux
          </div>
          <div className="flex gap-2">
            {[
              {
                icon: Linkedin,
                label: "LinkedIn",
                href: "https://www.linkedin.com/company/wayne-cote-d-ivoire/",
              },
              {
                icon: Facebook,
                label: "Facebook",
                href: "https://www.facebook.com/WayneCotedivoire/",
              },
            ].map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={s.label}
                data-testid={`footer-social-${s.label.toLowerCase()}`}
                className="w-10 h-10 flex items-center justify-center border border-white/15 hover:bg-[#E85D26] hover:border-[#E85D26] transition-all"
              >
                <s.icon size={16} />
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10">
        <div className="kip-container py-6 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-white/50">
          <div>
            © {new Date().getFullYear()} KIP Energy — Tous droits réservés.
          </div>
          <div className="flex gap-6">
            <a href="#" className="hover:text-[#E85D26] transition-colors">
              Mentions légales
            </a>
            <a href="#" className="hover:text-[#E85D26] transition-colors">
              Confidentialité
            </a>
            <a href="#" className="hover:text-[#E85D26] transition-colors">
              CGU
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
